module.exports = __webpack_public_path__ + "static/media/distribution.4122c3e4.png";